var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTorch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.9 737.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.75;}.cls-2{fill:#4cb3d3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "161.52 512.64 229.69 512.64 255.4 490.23 255.4 479 161.52 479 162.8 479 68.92 479 68.92 490.23 94.63 512.64 162.8 512.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.33 497.53 223.33 694.79 194.35 714.9 194.35 487.42 223.33 497.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.63 497.53 101.63 694.79 130.61 714.9 130.61 487.42 101.63 497.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.84 727.16 162.66 737.22 151.48 727.16 151.48 495.82 172.84 495.82 172.84 727.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.46,461.9c11.82,3.55,60.81,3.64,60.81,3.64S224.06,419.09,222.88,353c-2.43-136-6.42-175.15-6.42-175.15s-6.59,44.93-32.87,90.65S153.91,341,156.27,381,204.64,458.36,216.46,461.9Z",
    transform: "translate(-155.65 -23.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.64,465.54c25.44,10.63,53.21,0,53.21,0s-55.05-55.32-57.94-106.16,26-76.26,41.39-121.19,4.73-89.92-4.73-122.4-23.65-62-49.66-92.78c0,0,26,46.29,0,110S254.82,201.73,242.13,257c-5.56,24.2-3.88,102.06,12,140.34C271.64,439.78,273.72,452.2,305.64,465.54Z",
    transform: "translate(-155.65 -23.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390,412.39c-13.84,12.9-38.12,8.06-38.12,8.06s17.79,44.24,48.53,45.09,68.42-27.92,66.05-76.2S449,305.28,431,259.48C420,231.69,411.3,221.66,412.9,195.89c1.52-24.5,6.25-35.73,6.25-35.73S382.63,202.43,382.5,237c-.07,16.55,32,84.18,31.92,116C414.37,372.19,408.9,394.76,390,412.39Z",
    transform: "translate(-155.65 -23.01)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.18 333.38 203.18 333.42 203.2 333.4 203.22 333.42 203.22 333.38 231.67 309.8 203.22 248.78 203.22 248.68 203.2 248.73 203.18 248.68 203.18 248.78 174.72 309.8 203.18 333.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.38,351.53l-30.53,22.9-30.53-22.9s-2.94,20.83,2.35,31.57,11.45,19.54,28.16,20.43h0c16.71-.89,22.88-9.7,28.16-20.43S389.38,351.53,389.38,351.53Z",
    transform: "translate(-155.65 -23.01)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorch);
export default __webpack_public_path__ + "static/media/torch.81bfeecc.svg";
export { ForwardRef as ReactComponent };